export default __webpack_public_path__ + "static/media/header_shelf.8b3acb9a.webp";